(function(){
  function reveal(root){
    var els=(root||document).querySelectorAll('.lx-reveal:not(.is-in)');
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in')});return;}
    var io=new IntersectionObserver(function(entries){entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('is-in');io.unobserve(en.target);}})},{rootMargin:'0px 0px -8% 0px',threshold:0.08});
    els.forEach(function(e){io.observe(e)});
  }
  function rails(root){
    (root||document).querySelectorAll('[data-lx-rail]').forEach(function(r){
      if(r.dataset.ready)return;r.dataset.ready='1';
      var t=r.querySelector('.lx-rail__track');
      r.querySelectorAll('[data-dir]').forEach(function(b){b.addEventListener('click',function(){
        var card=t.firstElementChild;var w=card?card.getBoundingClientRect().width+16:300;
        t.scrollBy({left:w*parseInt(b.dataset.dir,10),behavior:'smooth'});
      })});
    });
  }
  function init(root){reveal(root);rails(root);}
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',function(){init()});
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();
